import React from 'react';
import { BookOpen } from 'lucide-react';
import ReinforcementComponent from './ReinforcementComponent';
// VideoPlayer is removed from here as it is now embedded inside the games/hub
import { useAppContext } from '../../../core/App';

const LessonPage = ({ part, onComplete, onExit, isReviewMode }) => {
  const { reinforcement, title } = part; 
  const { schoolConfig } = useAppContext(); 

  // --- STRATEGIC SHIFT: "ACTION FIRST" ---
  // We no longer force users to watch videos before playing.
  // The video content is now delivered as "Cheat Codes" inside the game 
  // or "Hype Reels" in the Hub.

  return (
    <div className="animate-fade-in h-full flex flex-col">
      
      {/* ALUMNI BANNER (Preserved logic) */}
      {schoolConfig?.content_overrides?.[part.id] && (
          <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3 mb-4 flex items-center text-indigo-800 text-xs font-bold uppercase tracking-wide">
             <span className="w-2 h-2 bg-indigo-600 rounded-full mr-2 animate-pulse"></span>
             Featured Alumni Content: {schoolConfig.name}
          </div>
      )}

      {isReviewMode && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6 flex items-center text-blue-800 text-sm">
          <BookOpen className="w-4 h-4 mr-2" />
          <span className="font-medium">Reference Mode</span>
        </div>
      )}

      <div className="flex items-center justify-between mb-6 border-b pb-4">
        <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
        <span className="text-sm text-gray-500">
            Interactive Simulation
        </span>
      </div>
      
      <div className="flex-grow">
        <ReinforcementComponent
            type={reinforcement.type}
            data={reinforcement}
            onComplete={onComplete}
            onBack={onExit} // Changed to onExit since there is no "Prev Video"
            isReviewMode={isReviewMode}
        />
      </div>
      
       {/* Footer logic for Review Mode */}
       {isReviewMode && (
          <div className="mt-8 pt-6 border-t text-center">
             <button onClick={onExit} className="text-gray-700 font-medium py-3 px-6 rounded-lg hover:bg-gray-100 border border-gray-300 transition">Return to Hub</button>
          </div>
      )}
    </div>
  );
};

export default LessonPage;